<template>
  <div
    v-if="storeData"
    class="store-container"
  >
    <div class="store-container__selector">
      <p>Select a country</p>
      <select @change="filterStores" v-model="storeOption" name="storeOption">
        <option v-for="(country, countryId) in countries" :key="countryId" :value="country">
          {{ country }}
        </option>
      </select>
    </div>
    <div class="store-locator__total">
      <p>
        <span class="store-locator--no-translate">{{ storesSelected.length }}</span>
        <span class="store-locator--info-text">online retailers for</span>
        <span class="store-locator--no-translate">{{ storeOption }}</span>
      </p>
      <p class="store-locator__total--info">Freight and duty charges may apply.</p>
    </div>
    <div class="store-container__results" v-if="storesSelected.length">
      <div v-for="(store, storeIndex) in storesSelected" :key="storeIndex" class="store-wrapper store-locator__results">
        <div class="store-locator__results--left">
          <a v-if="store['main-link']" :href="store['main-link']" target="_blank">
            <img v-if="store.logo" :src="store.logo" :alt="store.title" class="store-wrapper__image">
          </a>
        </div>
        <div class="store-locator__results--left">
          <a :href="store['main-link']" target="_blank" class="store-container__title">
            {{ store.title }}
            <span>{{ store['main-link'] }}</span>
          </a>
        </div>
        <div class="store-locator__results--center">
          <a
            v-if="store.stores"
            :href="store.stores"
            target="_blank"
            class="btn quick-view-button__button quick-product__btn buy-it-with__button store-locator__button"
            >
              Find a Store
          </a>
        </div>
        <div class="product__check-out-btn store-locator__results--right">
          <a
            v-if="store['product-link']"
            :href="store['product-link']"
            target="_blank"
            style="text-transform: uppercase;"
            class="btn btn--full add-to-cart text-title-15 store-locator__button"
          >
            Buy online
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<!--
CSV file format:
 Header: logo,	title,	main-link,	stores,	product-link,	country
-->

<script>
export default {
	selector: "#vue-store-locator",
  props: {
    file: { type: String },
    defaultcountry: { type: String }
  },
  data () {
    return {
      storeData: null,
      countries: [],
      storesSelected: [],
      storeOption: 0,
      firstLoad: true,
    }
  },
  mounted () {
    this.readCSVFile()
  },
  methods: {
    defaultList () {
      this.storeOption = this.defaultcountry
      this.$nextTick(() => {
        this.filterStores()
      })
    },
    filterStores () {
      this.storesSelected = []
      this.storeData.forEach(store => {
        if (store.country == this.storeOption) {
          this.storesSelected.push(store)
        }
      })
    },
    getCountriesList () {
      this.storeData.forEach(store => {
        if(!this.countries.includes(store.country)) {
          this.countries.push(store.country)
        }
      })
      this.countries.sort()
    },
    parseCSVFile (csvText) {
      csvText = csvText.replaceAll('\r', '')
      const lines = csvText.split('\n')
      const header = lines[0].split(',')
      const output = lines.slice(1).map(line => {
        const fields = line.split(',')
        return Object.fromEntries(header.map((h, i) => [h, fields[i]]))
      })
      this.storeData = output
      if (this.storeData) {
        this.getCountriesList()
        if (this.firstLoad) {
          this.firstLoad = false
          this.defaultList()
        }
      }
    },
    async readCSVFile() {
      if (this.file) {
        try {
          const fetchResponse = await fetch(this.file)
          const csvText = await fetchResponse.text()
          this.parseCSVFile(csvText)
        } catch (ex) {
          console.log("Error in readCSVFile")
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.store-container {
  margin: auto;
  padding: 20px 0 160px;

  &__selector {
    text-align: center;
    padding: 40px 0;
    background-color: var(--divaBackgroundSection2);
    color: var(--divaTextColor);

    p {
      font-family: $font-founder-regular;
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
      letter-spacing: 0.05em;
      text-align: center;
      text-transform: uppercase;
      padding-bottom: 24px;
    }

    select {
      font-family: $font-founder-regular;
      font-size: 14px;
      font-weight: 500;
      line-height: 19px;
      letter-spacing: 0.03em;
      text-align: left;
      width: 370px;
      text-transform: uppercase;
      background-color: white;
      padding: 16px;
    }
  }

  &__title {
    font-family: $font-founder-regular;
    font-size: 24px;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    flex-direction: column;
    color: var(--divaTextColor);
    span {
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.01em;
      text-align: left;
      padding-top: 8px;
    }
  }

  &__results {
    max-width: 920px;
    margin: auto;
  }
}

.store-wrapper {
  &__image {
    width: 160px;
    height: auto;
  }
}

@media screen and (max-width: 768px) {
  .store-container {
    padding: 20px 0 60px;

    &__selector select {
      width: 300px;
    }
  }
}

@media screen and (max-width: 380px) {
  .store-container {
    &__title {
      padding: 14px 0 20px;
    }

    &__button {
      margin: 8px 0;
    }
  }
}
</style>
